import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class AnalyticsRoutesTracker extends Component {
    componentDidMount = () => {
        this.trackRoute();
    };

    componentDidUpdate = (prevProps) => {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged = () => {
        this.trackRoute();
    };

    trackRoute = () => {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'Pageview',
                'pagePath': this.props.location.pathname,
                'pageTitle': this.props.location.pathname
            });
        } catch (ex) {}
    }

    render() {
        return null;
    }
}

export default withRouter(AnalyticsRoutesTracker);
